import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Skeleton } from 'ant-design-vue';

interface ParagraphProps {
  rows?: number;
  width?: number | string | Array<number | string>;
}
interface Props {
  active?: boolean;
  loading: boolean;
  avatar?: boolean;
  paragraph?: boolean | ParagraphProps;
  title?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RexSkeletonV3',
  props: {
    active: { type: Boolean, default: true },
    loading: { type: Boolean },
    avatar: { type: Boolean, default: false },
    paragraph: { type: [Boolean, Object], default: () => ({ rows: 4 }) },
    title: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Skeleton), {
      active: props.active,
      loading: props.loading,
      avatar: props.avatar,
      paragraph: props.paragraph,
      title: props.title
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["active", "loading", "avatar", "paragraph", "title"])
  ]))
}
}

})